import {LoadingOutlined} from '@ant-design/icons';

import {LoadingContainer} from './Loading.styled';

const Loading = () => (
  <LoadingContainer>
    <LoadingOutlined />
  </LoadingContainer>
);

export default Loading;
